import { getCurrencyOfferByPeriod } from "../../../../../../lib/Plans";

export const getAvailablePlanNames = ({ currentOffer, currentPeriod }) => {
  const plans = currentOffer.plans;

  const planNames = [];

  for (const plan of plans) {
    const currencyOffer = getCurrencyOfferByPeriod({
      currency_offers: plan.currency_offers,
      period: currentPeriod
    });

    if (currencyOffer) {
      planNames.push(plan.name);
    }
  }

  return planNames;
};
